import { Pause as PauseIcon, PlayArrow as PlayArrowIcon } from "@mui/icons-material";
import Box from "@mui/material/Box";
import { useContext } from "react";

import { AudioAppContext } from "@/models/AudioAppContextProvider.tsx";
import { UxContext } from "@/models/UxStateProvider.tsx";

export default function PlayButtonOpenPlayer({
  itemId,
  hasPlayableAudio,
}: {
  itemId: string;
  hasPlayableAudio: boolean;
}) {
  const { pauseItem, playerPlaying, playItem, activeItemId, setActiveItemId } = useContext(AudioAppContext);
  const { setFeedViewCollapsed, feedViewCollapsed } = useContext(UxContext);
  const activePlayItem = activeItemId === itemId;
  const itemPlaying = activePlayItem && playerPlaying;

  const togglePlay = () => {
    if (!feedViewCollapsed) {
      setFeedViewCollapsed((value) => !value);
    }
    if (itemPlaying) {
      pauseItem();
      return;
    }
    if (!itemPlaying && itemId === activeItemId) {
      playItem();
      return;
    }
    setActiveItemId(() => itemId);
  };

  return (
    <>
      {hasPlayableAudio && (
        <Box
          component="button"
          disabled={!hasPlayableAudio}
          sx={{
            color: "white",
            ...(!hasPlayableAudio
              ? { bgcolor: "var(--color-zinc-700)", color: "var(--color-zinc-400)", cursor: "not-allowed" }
              : { bgcolor: "#22c55e", "&:hover": { bgcolor: "#16a34a" }, cursor: "pointer" }),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50px",
            py: 0.5,
            pl: 0.5,
            pr: 1.5,
            width: "100%",
            border: "none",
          }}
          onClick={() => togglePlay()}
        >
          {itemPlaying ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <PauseIcon role="img" sx={{ fontSize: 20 }} />
              <Box sx={{ fontSize: "0.875rem", fontWeight: 600 }}>Pause</Box>
            </Box>
          ) : (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <PlayArrowIcon role="img" sx={{ fontSize: 20 }} />
              <Box sx={{ fontSize: "0.875rem", fontWeight: 600 }}>Listen</Box>
            </Box>
          )}
        </Box>
      )}
    </>
  );
}
